"use client";

import { sendEvent } from "@/lib/utils/analytics";
import { useMediaQuery } from "@/hooks/use-media-query";
import { type TouchpointType } from "@/lib/quiz-attribution";

const hormoneList = [
  { color: "#45804F", text: "Estrogen, which rises 3-4 days before ovulation" },
  { color: "#C188FF", text: "LH, which surges 24-36 hours before ovulation" },
  { color: "#5790FF", text: "PdG, which rises after ovulation" },
  { color: "#F96512", text: "FSH, to track follicle growth" },
];

interface WhatMakesInitoDifferentProps {
  onCtaClick: () => void;
  touchpointType?: TouchpointType;
}

export default function WhatMakesInitoDifferent({ onCtaClick, touchpointType }: WhatMakesInitoDifferentProps) {
  const isMobile = useMediaQuery("(max-width: 768px)");


  return (
    <div className="my-12 px-5 w-full box-border md:max-w-[500px]">
      <h2 className="flex flex-nowrap items-center gap-2 pb-2 text-[#232221] title-24 mb-6">
        What makes{" "}
        <img
          src="https://cdn.inito.com/rebrand_quiz/v1/logo/logoInito.svg"
          alt="Inito Logo"
          className="w-[60px] h-auto shrink-0"
        />{" "}
        different?
      </h2>

      <p className="title-16 text-[#112d35] mb-6">
        Inito is the only fertility monitor that measures all{" "}
        <strong className="font-bold tracking-[-0.2px]">
          4 hormones on a single test strip,
        </strong>{" "}
        showing you a full picture of your cycles with results unique to your
        body.
      </p>

      <div
        style={{
          borderRadius: "11px",
          background: isMobile
            ? `url('https://cdn.inito.com/landing_page/section/product_purchase/ng_product_purchase.webp') lightgray -97.236px -183.204px / 140.9% 202.771% no-repeat`
            : `url('https://cdn.inito.com/landing_page/section/product_purchase/ng_product_purchase.webp') lightgray -120.236px -250.204px / 140.9% 202.771% no-repeat`,
          height: isMobile ? "230px" : "300px",
          width: isMobile ? undefined : "100%",
          maxWidth: isMobile ? "500px" : undefined,
          marginBottom: "20px",
        }}
      />

      <div className="flex flex-col gap-5 w-full max-w-[350px] md:max-w-[500px] md:pb-[30px]">
        {hormoneList.map((item, index) => (
          <div key={index} className="flex items-start gap-3.5">
            <span
              className="w-[15px] h-[15px] mt-1 rounded-[3px] shrink-0"
              style={{ backgroundColor: item.color }}
            />
            <p className="title-16 text-[#232221] m-0">
              {item.text}
            </p>
          </div>
        ))}
      </div>

      <div className="w-full max-w-[440px] md:max-w-[500px] flex items-center justify-center py-5">
        <button
          className="flex w-full py-3 px-[30px] justify-center items-center self-stretch rounded-lg bg-[#232221] text-white text-center title-16 border-none cursor-pointer transition-colors duration-300"
          onClick={() => {
            sendEvent("track_hormones_clicked", {
              quiz_source: "bottom_sheet",
              touchpoint_type: touchpointType,
            });
            onCtaClick();
          }}
        >
          Track your Hormones with Inito
        </button>
      </div>
    </div>
  );
}
